import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ typography, spacing }) => ({
  chip: {
    height: spacing(30),
    '& .MuiChip-label': { ...typography.body2, padding: spacing(8, 14) },
  },
}))
